import React, { forwardRef } from 'react';

import { MobileSlideIn } from '@pdcfrontendui/components';
import { Prettify } from '@pdcfrontendui/types';
import { useIsDualView } from '@pdcfrontendui/hooks';
import useParallax from '../hooks/useParallax';

function SlideInPre(
  props: Prettify<
    Omit<Parameters<typeof MobileSlideIn>[0], 'bottom' | 'isMobile'> & {
      noAnimation?: boolean;
    }
  >,
  ref: React.Ref<HTMLDivElement>
) {
  const dualView = useIsDualView();

  useParallax(!!props.children && !dualView && !props.noAnimation);
  return (
    <MobileSlideIn
      {...props}
      bottom={50}
      isMobile={!dualView && !props.noAnimation}
      ref={ref}
    />
  );
}

export const SlideIn = forwardRef(SlideInPre);
